// routes
import { PATH_DASHBOARD } from "../../../routes/paths";
// components
import Iconify from "../../../components/Iconify";
import { useTranslation } from "react-i18next";
// ----------------------------------------------------------------------

const getIcon = (name) => (
  <Iconify icon={name} sx={{ width: 1, height: 1 }} />
);

const ICONS = {
  dashboard: getIcon("solar:widget-5-bold-duotone"),
  supervisor: getIcon("solar:user-id-bold-duotone"),
  agent: getIcon("solar:users-group-rounded-bold-duotone"),
  customer: getIcon("solar:user-circle-bold-duotone"),
  security_and_limit: getIcon("solar:shield-keyhole-bold-duotone"),
  user: getIcon("solar:settings-bold-duotone"),
  ticket: getIcon("solar:ticket-bold-duotone"),
  report: getIcon("solar:chart-square-bold-duotone"),
  configuration: getIcon("solar:tuning-2-bold-duotone"),
  vendor: getIcon("solar:shop-2-bold-duotone"),
  refund: getIcon("solar:refresh-circle-bold-duotone"),
  edit_money: getIcon("solar:pen-new-square-bold-duotone"),
};

const NavConfig = () => {
  const { t } = useTranslation();
  const navConfig = [
    // GENERAL
    // ----------------------------------------------------------------------
    {
      subheader: t("sideBar.OVERVIEW"),
      items: [
        {
          title: t("sideBar.OVERVIEW"),
          path: PATH_DASHBOARD.general.app,
          icon: ICONS.dashboard,
        },
        {
          title: t("sideBar.supervisor"),
          path: PATH_DASHBOARD.supervisor.root,
          icon: ICONS.supervisor,
          children: [
            {
              title: t("sideBar.add_supervisor"),
              path: PATH_DASHBOARD.supervisor.add,
            },
            {
              title: t("sideBar.list_supervisor"),
              path: PATH_DASHBOARD.supervisor.list,
            },
          ],
        },
        {
          title: t("sideBar.vendor"),
          path: PATH_DASHBOARD.agent.root,
          icon: ICONS.vendor,
          children: [
            { title: t("sideBar.add_vendor"), path: PATH_DASHBOARD.agent.add },
            {
              title: t("sideBar.list_vendor"),
              path: PATH_DASHBOARD.agent.list,
            },
          ],
        },
        // {
        //   title: t("p_ticket.cancelTicket"),
        //   path: PATH_DASHBOARD.ticket.refund,
        //   icon: ICONS.refund,
        // },
        // {
        //   title: t("p_ticket.editTicket"),
        //   path: PATH_DASHBOARD.ticket.edit_ticket,
        //   icon: ICONS.edit_money,
        // },
      ],
    },
    {
      subheader: t("sideBar.TRANSACTIONS"),
      items: [
        {
          title: t("sideBar.ticket_sale"),
          path: PATH_DASHBOARD.ticket.sale,
          icon: ICONS.ticket,
        },
        {
          title: t("sideBar.report_sale"),
          path: PATH_DASHBOARD.report.sale,
          icon: ICONS.report,
        },
        {
          title: t("params.all_transaction"),
          path: PATH_DASHBOARD.configuration.root,
          icon: ICONS.ticket,
          children: [
            {
              title: t("sideBar.commission_distribution"),
              path: PATH_DASHBOARD.report.commission_distribution,
              icon: ICONS.report,
            },
            {
              title: t("params.all_transaction"),
              path: PATH_DASHBOARD.report.transactions,
              icon: ICONS.report,
            },
            {
              title: t("sideBar.manual_deposits"),
              path: PATH_DASHBOARD.report.manual_deposits,
              icon: ICONS.report,
            },
            {
              title: t("sideBar.manual_transfers"),
              path: PATH_DASHBOARD.report.manual_transfers,
              icon: ICONS.report,
            },
          ],
        },
      ],
    },
    {
      subheader: t("sideBar.configuration"),
      items: [
        {
          title: t("sideBar.configuration"),
          path: PATH_DASHBOARD.configuration.root,
          icon: ICONS.configuration,
          children: [
            {
              title: t("p_usercommission.usercommission"),
              path: PATH_DASHBOARD.configuration.usercommission,
            },
            {
              title: t("sideBar.exchange_rate"),
              path: PATH_DASHBOARD.configuration.exchange_rate,
            },
            {
              title: t("sideBar.feegenerale"),
              path: PATH_DASHBOARD.configuration.fee,
            },
            {
              title: t("sideBar.payment_instructions"),
              path: PATH_DASHBOARD.configuration.payment_instruction,
            },
            {
              title: t("sideBar.manual_transfer_account_types"),
              path: PATH_DASHBOARD.configuration.manual_transfer_account_types,
            },
            {
              title: t("sideBar.manual_transfer_payment_methods"),
              path: PATH_DASHBOARD.configuration.manual_transfer_payment_methods,
            },
            {
              title: t("sideBar.manual_transfer_senders"),
              path: PATH_DASHBOARD.configuration.manual_transfer_senders,
            },
            {
              title: t("sideBar.manual_transfer_beneficiaries"),
              path: PATH_DASHBOARD.configuration.manual_transfer_beneficiaries,
            },
            {
              title: t("sideBar.manual_transfer_payers"),
              path: PATH_DASHBOARD.configuration.manual_transfer_payers,
            },
            {
              title: t("sideBar.manual_transfer_fees"),
              path: PATH_DASHBOARD.configuration.manual_transfer_fees,
            },
            {
              title: t("sideBar.limit_transaction_generale"),
              path: PATH_DASHBOARD.security_and_limit
                .limit_transaction_generale,
            },
          ],
        },
      ],
    },

    // PARAMETTRE
    // ----------------------------------------------------------------------
    {
      subheader: "Paramettre",
      items: [
        // USER
        {
          title: t("sideBar.user"),
          path: PATH_DASHBOARD.user.account,
          icon: ICONS.user,
        },
      ],
    },
  ];
  return navConfig;
};

export default NavConfig;
